var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "well" }, [
    _c("h4", [_vm._v("Categories")]),
    _vm._v(" "),
    _c(
      "ul",
      _vm._l(_vm.categories, function(category) {
        return _c(
          "li",
          { key: category.id },
          [
            _c(
              "router-link",
              {
                attrs: { to: { name: "category", params: { id: category.id } } }
              },
              [_vm._v(_vm._s(category.name))]
            )
          ],
          1
        )
      })
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b784ee22", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b784ee22","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/js/components/CategoriesList.vue
// module id = 375
// module chunks = 0